import type { CMYKColor } from "../types/colors/CMYKColor"
import type { Color } from "../types/colors/Color"
import { RgbToCmyk } from "./RgbToCmyk"
import { ToRgb } from "./ToRgb"

/**
 * Converts a Color to a CMYKColor
 * If the input is already CMYK, it will be returned as is
 * If the input is RGB or HSL, it will be converted to CMYK
 */
export const ToCmyk = (color: Color): CMYKColor => {
  if ("c" in color) {
    // It's already a CMYKColor
    return color
  } else if ("r" in color) {
    // It's an RGBColor, convert to CMYK
    return RgbToCmyk(color)
  } else {
    // It's an HSLColor, first convert to RGB, then to CMYK
    const rgb = ToRgb(color)
    return RgbToCmyk(rgb)
  }
}
